import { render, staticRenderFns } from "./PruebasRapidas.vue?vue&type=template&id=38911baa&"
import script from "./PruebasRapidas.vue?vue&type=script&lang=js&"
export * from "./PruebasRapidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports